define([
    'text!fnjinews2021/component/main.html',
    'common/api',
    'fnjinews2021/common/api',
    'jquery',
    'common/utils',

    'WebmCommon/utils',
    'fnjinews/component/image-slick',
    'fnjinews2021/component/time-axis',
    'fnjinews2021/component/swiper-video'


], function(
    tpl,Api,NewApi,$,Utils,UtilsCommon,ImageSlick,TimeAxis,SwiperVideo
){
    return {
        template: tpl,
        data: function(){
            return {
                isPC: true,
                hasDesigner: false,
                fnjinewsImg: [
                    {name: '冰山沙发宣传片',time: '2021年',
                        img: 's20480_1627525858_4140.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/bedae17b3701925921700019554/v.f30.mp4'},
                    {name: '梵游记',time: '2019年',
                        img: 's20480_1627526616_2558.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/ba35047e5285890799896941222/v.f20.mp4'},
                    {name: '李宅夏午',time: '2018年',
                        img: 's20480_1627526124_2093.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/10240b895285890805950262109/v.f20.mp4'},
                    {name: 'FF线宣传片',time: '2018年',
                        img: 's20480_1627526246_5860.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/14e234925285890805950475751/v.f20.mp4'},
                    {name: '2017新品广告片',time: '2017年',
                        img: 's20480_1627526269_6608.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/a271987e3701925921713729311/v.f30.mp4'},
                    {name: '春夏秋冬',time: '2014年',
                        img: 's20480_1627526343_2499.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/d869deca5285890805966888967/v.f20.mp4'},
                    {name: '2013年新品广告片',time: '2013年',
                        img: 's20480_1627526368_7352.png',
                        video: 'http://1257018232.vod2.myqcloud.com/0c8e29a6vodtransgzp1257018232/22b1a9995285890805967733573/v.f30.mp4'}
                ],
                fnjinews: [],
                years: [],

                productsImg: [
                    {img:'s20480_1627452972_1499.png',name: '竹椅',ename: ' BAMBOO CHAIR',info1: '以木代替竹子，外形经过提炼与简化，线条呈现粗细变化，简洁质朴中流动着',info2: '中式意蕴，是梵几品牌的开端。'},
                    {img:'s20480_1627452940_9411.png',name: '团扇屏风',ename: ' CIRCULAR FAN SCREEN',info1: '木与藤虚实交错，空气流转之间，让传统中式元素融入现代的空间动线和生活方式，',info2: '空间隔断不再是一种切割，而是成为一种人与人之间既可交流、又相互独立的关系。'},
                    {img:'s20480_1627452916_7972.png',name: '胡同推车',ename: ' LITTLE CART',info1: '以中国传统的竹推车为灵感依托，用中式特有的设计语言回归记忆中最质朴的',info2: '空间需求，不为家具功能所限定，灵活适用于家中的各个空间和场景。'},
                    {img:'s20480_1627452875_7826.png',name: '线轴几',ename: ' REEL SIDE TABLE',info1: '细腻变化的自然石材肌理形成更加丰富的触感，',info2: '高低错落组合衬出独具灵气的东方美。'},
                    {img:'s20480_1627452846_8757.png',name: 'CIGAR置物架',ename: ' CIGAR DISPLAY SHELF',info1: '取竹编簸箕架之形，又灌之以现代设计的巧思，四个方向均可拿取和展示物',info2: '品，纵横交错中勾勒出重叠的美感。'},
                    {img:'s20480_1627452815_5473.png',name: '马扎',ename: ' CAMPSTOOL',info1: '圆滑细腻的木质架构形成可随身提携的拎手，色泽温润的植鞣坐面注入时间的',info2: '自然印记。'},
                    {img:'s20480_1627452661_7271.png',name: '鸟笼立柜',ename: ' CAGE CABINET',info1: '参照鸟笼的笼体，厚实且造型独特的木条温润包围，柔和灯光中呈现虚实互通',info2: '的视觉体系。'}
                ],
                productTheNum: 0,

                currYear:2020,
                isZh: true,
                fnjiNewsInfo: {},
                photo: 4,
                moreClickShow: true,
                windowWidth: 1440,
                designer: [],
            };
        },
        components: {
            ImageSlick:ImageSlick,
            TimeAxis:TimeAxis,
            SwiperVideo:SwiperVideo
        },
        computed: {
            clickInCss: function(){
                return {transition: 'all 1s',opacity: '1'};
            },
            clickOutCss: function(){
                return {transition: 'all 0.6s',opacity: '0'};
            }
        },
        created: function () {
            var obj = this;
            obj.windowWidth = $(window).width();
        },
        methods: {
            pcIs: function(){
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                }else {
                    obj.isPC = true;
                }
            },
            init:function () {
                this.changeYear();
                // this.initYear();
                var obj = this;
                $(document).on("click", ".news-year div", function () {
                    var year = $(this).attr("year");
                    obj.onChangeYear(year);
                })
            },
            onChangeYear:function (year) {
                var allNews = $("li.fnji-news[year='"+year+"']");
                var top = $(allNews[0]).offset().top;
                UtilsCommon.scrollTo(top-80);
            },
            changeYear: function () {
                var obj = this;
                Api.getAllFnjiNews.ajax({}).done(function (data) {
                    obj.fnjinews = data.tableData;
                    obj.years = data.years;
                    Utils.emitPageReady();
                });
            },
            locale: function(){
                var _this = this;
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                    // _this.fnjiNewsInfo = _this.$i18n.messages.en.aboutFnjiNew;
                    _this.productsImg = _this.$i18n.messages.en.aboutFnjiNew.productsImg;
                }else {
                    _this.isZh = true;
                    // _this.fnjiNewsInfo = _this.$i18n.messages.zh.aboutFnjiNew;
                    _this.productsImg = _this.$i18n.messages.zh.aboutFnjiNew.productsImg;
                }
            },
            imgShow: function (index) {
                var obj = this;
                obj.productTheNum = index;
                $('.fnjinews2021-product-left-img div').css(obj.clickOutCss);
                $('.fnjinews2021-product-left-img').eq(index).find('div').css(obj.clickInCss);
                $('.fnjinews2021-product-left-name').css(obj.clickOutCss);
                $('.fnjinews2021-product-left-name').eq(index).css(obj.clickInCss);
            },
            slickProducts: function () {
                var obj = this;
                var num = 0;
                setInterval(function () {
                    if(num===6){num = 0;}else {num+=1}
                    $('.fnjinews2021-theproduct-item-phone').css(obj.clickOutCss);
                    $('.fnjinews2021-theproduct-item-phone').eq(num).css(obj.clickInCss);
                },3000);
            },
            getImages: function(){
                var _this = this;
                var params = {
                    page: 1,
                    limit: 1000,
                    lang: ''
                };
                if(_this.$i18n.locale=='en'){
                    params.lang = 'en';
                }
                return NewApi.getDesignerListApi.ajax({data: JSON.stringify(params)})
                    .done(function(data){
                        _this.designer = data.tableData;
                        // _this.visitList = data.fnjiDrop;
                        // _this.slickInfo();
                    });
            },
        },
        watch: {
            '$i18n.locale': function () {
                this.locale();
            }
        },
        mounted: function(){
            var obj = this;
            this.pcIs();
            this.locale();
            this.init();
            this.slickProducts();
            this.getImages();
            // isPlay();
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
    function isPlay () {
        var video1 = $("#video1").get(0);
        var video2 = $("#video2").get(0);
        var video3 = $("#video3").get(0);
        var video4 = $("#video4").get(0);
        setInterval(function () {
            if(video1.paused){
                $("#video1-words").removeClass('hide');
            }else {
                $("#video1-words").addClass('hide');
            }
            if(video2.paused){
                $("#video2-words").removeClass('hide');
            }else {
                $("#video2-words").addClass('hide');
            }
            // if(video3.paused){
            //     $("#video3-words").removeClass('hide');
            // }else {
            //     $("#video3-words").addClass('hide');
            // }
        },500);
    }
});



//////////////////
// WEBPACK FOOTER
// ./fnjinews2021/component/main.js
// module id = 115
// module chunks = 0